import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import {
  BorderStyleEnum,
  BorderType,
  BorderTypeEnum,
} from 'common/types/styleTypes'
import React from 'react'
import { SelectNew } from 'src/editor/shared/ui-lib/select-new/select-new'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { TypedTFunctionInterface } from 'src/shared/i18next/types/typed-t-function-interface'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'

const getBorderTypeChoices = (
  t: TypedTFunctionInterface,
): Array<OptionType> => {
  return [
    {
      label: t('website_styles_settings.border_style.none'),
      value: BorderStyleEnum.none,
    },
    {
      label: t('website_styles_settings.border_type.full_border'),
      value: BorderTypeEnum.fullBorder,
    },
    {
      label: t('website_styles_settings.border_type.bottom_only'),
      value: BorderTypeEnum.bottomOnly,
    },
    {
      label: t('website_styles_settings.border_type.top_only'),
      value: BorderTypeEnum.topOnly,
    },
    {
      label: t('website_styles_settings.border_type.top_and_bottom'),
      value: BorderTypeEnum.topAndBottom,
    },
  ]
}

type OptionType = {
  label: string
  value: BorderTypeEnum | BorderStyleEnum.none
}

interface BorderTypeControlProps {
  border: Partial<BorderType> | undefined
  mobileBorder?: Partial<BorderType> | undefined
  update: (value: Partial<BorderType>) => void
  mobileUpdate?: ((value: Partial<BorderType>) => void) | undefined
  label?: string
}

export const BorderTypeControl = ({
  border,
  mobileBorder,
  update,
  mobileUpdate,
  label = 'website_styles_settings.border_type.label',
}: BorderTypeControlProps) => {
  const { t } = useTypedTranslation()
  const { isMobile } = useDeviceModeContext()

  const resultBorder = getMobileOrDesktop(border, mobileBorder, isMobile)
  const resultUpdate = getMobileOrDesktop(update, mobileUpdate, isMobile)

  const borderTypeOptions = getBorderTypeChoices(t)

  const onChangeType = (prop: OptionType | null) => {
    if (prop) {
      if (prop?.value === BorderStyleEnum.none) {
        resultUpdate({
          ...resultBorder,
          style: prop.value,
        })
      } else {
        resultUpdate({
          ...resultBorder,
          style:
            !resultBorder?.style || resultBorder.style === BorderStyleEnum.none
              ? BorderStyleEnum.solid
              : resultBorder?.style,
          type: prop.value,
        })
      }
    }
  }

  return (
    <SelectNew
      labelText={label}
      options={borderTypeOptions}
      selectedOption={
        borderTypeOptions.find(
          ({ value }) =>
            value ===
            (resultBorder?.style === BorderStyleEnum.none
              ? BorderStyleEnum.none
              : resultBorder?.type),
        ) || borderTypeOptions[0]
      }
      onChange={onChangeType}
    />
  )
}
